import { Col, Modal, Row, Form, Input, Select } from 'antd';
import * as React from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { Provider, Subscribe } from 'unstated';

import { StateContainer } from './StateContainer';
import LanguageSelect from '../../../components/Others/LanguageSelect';

interface IStaticDocumentDetailProps {
  staticDocument: GQL.IStaticDocument;
  onSave: (staticDocument: GQL.IStaticDocument) => void;
  onCancel: () => void;
  languages: Array<GQL.ILanguage>;
}

export default class StaticDocumentDetail extends React.Component<IStaticDocumentDetailProps> {
  private staticDocumentContainer: StateContainer;

  public constructor(props: IStaticDocumentDetailProps) {
    super(props);
    this.staticDocumentContainer = new StateContainer({
      staticDocument: props.staticDocument,
      languages: props.languages
    });

    this.save = this.save.bind(this);
  }

  public render() {
    const { staticDocument } = this.staticDocumentContainer.state;
    const container = this.staticDocumentContainer;
    var toolbarOptions = [
      ['bold', 'italic', 'underline', 'strike'], // toggled buttons
      ['blockquote', 'code-block'],

      [{ header: 1 }, { header: 2 }], // custom button values
      [{ list: 'ordered' }, { list: 'bullet' }],
      [{ script: 'sub' }, { script: 'super' }], // superscript/subscript
      [{ indent: '-1' }, { indent: '+1' }], // outdent/indent
      [{ direction: 'rtl' }], // text direction

      [{ size: ['small', false, 'large', 'huge'] }], // custom dropdown
      [{ header: [1, 2, 3, 4, 5, 6, false] }],

      [{ color: [] }, { background: [] }], // dropdown with defaults from theme
      [{ font: [] }],
      [{ align: [] }],

      ['clean'] // remove formatting button
    ];

    return (
      <Provider>
        <Modal
          // maskClosable={false}
          style={{ top: '5vh' }}
          width={'80%'}
          bodyStyle={{ minHeight: '80vh' }}
          title={
            this.props.staticDocument == undefined || this.props.staticDocument.id == undefined
              ? 'New payment method'
              : `Payment method ${staticDocument.title}`
          }
          visible={true}
          cancelText={'Close'}
          okText={'Save changes'}
          onOk={this.save}
          onCancel={() => this.props.onCancel()}
        >
          <Subscribe to={[container]}>
            {productDetail => (
              <Row>
                <Col span={24}>
                  <Form>
                    <Form.Item
                      validateStatus={this.languageInputsStatus()}
                      hasFeedback={true}
                      label={'Current language'}
                      style={{ width: 100 }}
                      extra={'You are editing the method in this language'}
                    >
                      <LanguageSelect
                        name={'language'}
                        value={productDetail.state.currentLanguage}
                        onChange={(e: any, language: GQL.ILanguage) => container.setState({ currentLanguage: language.value })}
                        languages={this.props.languages}
                      />
                    </Form.Item>
                    <Form.Item
                      validateStatus={this.validateStatus('title')}
                      help={this.validateMessage('title')}
                      label={'Title'}
                      required={true}
                    >
                      <Input
                        name={'title'}
                        autoFocus={true}
                        placeholder="Internal title. For example &quot;Obchodni podminky&quot;"
                        addonBefore={'Internal'}
                        defaultValue={this.staticDocumentContainer.state.staticDocument.title}
                        onChange={e => {
                          this.onChange('title', e.target.value);
                        }}
                      />
                    </Form.Item>
                    <Form.Item label={'System tags'} extra={'For example "obchodni podminky"'}>
                      <Select
                        mode="tags"
                        defaultValue={container.state.staticDocument.tags || []}
                        style={{ width: '100%' }}
                        placeholder=""
                        onChange={(tags: string[]) => this.onChange('tags', tags)}
                      />
                    </Form.Item>
                    <Form.Item label={'Editor'}>
                      <ReactQuill
                        modules={{ toolbar: toolbarOptions }}
                        defaultValue={
                          (this.staticDocumentContainer.state.staticDocument.html || {})[
                          container.state.currentLanguage
                          ]
                        }
                        onChange={content =>
                          this.onChange('html', content, container.state.currentLanguage)
                        }
                      />
                    </Form.Item>
                  </Form>
                </Col>
              </Row>
            )}
          </Subscribe>
        </Modal>
      </Provider>
    );
  }

  private onChange(key: string, val: any, language?: string) {
    this.staticDocumentContainer.onChange(key, val, language);
  }

  private validateMessage(field: string) {
    const error = this.staticDocumentContainer.state.errors[field];
    const warning = this.staticDocumentContainer.state.warnings[field];

    if (error) {
      return error;
    }

    return warning;
  }

  private validateStatus(field: string) {
    const error = this.staticDocumentContainer.state.errors[field];
    const warning = this.staticDocumentContainer.state.warnings[field];

    if (error) {
      return 'error';
    }
    if (warning) {
      return 'warning';
    }

    return undefined;
  }

  private languageInputsStatus() {
    let valid = true;
    for (const key of Object.keys(this.staticDocumentContainer.state.warnings)) {
      if (this.staticDocumentContainer.state.warnings[key] != undefined) {
        // console.log(`returning false cause ${key} is not valid`, {
        //     stuff: this.props.container.state.warnings.generalSettings
        // });
        valid = false;
        break;
      }
    }

    if (valid) {
      return undefined;
    }

    return 'warning';
  }

  private async save() {
    const errors = await this.staticDocumentContainer.validate(); // TODO
    let anyError = false;

    for (const key of Object.keys(errors)) {
      if (errors[key] != undefined) {
        anyError = true;
      }
    }

    if (!anyError) {
      this.props.onSave(this.staticDocumentContainer.state.staticDocument);
    } else {
      console.log('there is error, can not save', errors);
    }
  }
}



// WEBPACK FOOTER //
// ./src/scenes/StaticDocuments/StaticDocumentDetail/StaticDocumentDetail.tsx